import { act } from "react-dom/test-utils";
import {
  GET_ALL_COMMON_SCHOOL,
  GET_ALL_COMMON_FRIENDS_LIST,
  GET_ALL_BLOCKED_USER_LIST,
  GET_ALL_COMMON_SUBJECTS,
  GET_LOGOUT_DATA,
  GET_ALL_COMMON_LANGUAGE,
  GET_ALL_COMMON_TAGS,
  GET_ALL_COMMON_GRADES,
  GET_ALL_COMMON_CURRICULUM_TRACK,
  GET_INDUSTRY_LIST,
  GET_REGION_LIST,
  GET_AREA_OF_INTEREST_LIST,
  GET_ALL_COMMON_PROFESSION,
  GET_ALL_COMMON_EXPECTATION_HELP,
  GET_ALL_COMMON_EXPECTATION_INTEREST,
  GET_ALL_COMMON_ALL_PROOF,
  NAVIGATION_TYPE,
  GET_USER_POINTS,
  GET_ALL_USER_COMMUNITY_LIST,
  GET_ALL_COMMON_CHAT_FRIENDS_LIST,
  HOME_IMAGE_STATUS,
  WORK_SPACE_TYPE,
  GET_USER_WORKSPACE_LIST,
  GET_ADMIN_CATEGORY_LIST,
  GET_ALL_COUNTRY_PHONE_CODE,
  WORK_SPACE_LOGIN,
  WORK_SPACE_WRONG_URL,
  GET_TOUR_STATUS,
  TRIGGER_TOUR_POPUP,
  SAVE_TOUR_STATUS,
  AFTER_TRIGGER_POPUP,
  ANNOUNCEMENT_DETAILS,
  GET_TAG_USER_LIST,
  GET_WORKSPACE_OPTIONS,
  HASH_TAG_LIST,
  NEED_RENDER_COMPONENT,
  GET_REQUIREMENT_STATUS,
  NEED_PHOTO_VERIFICATION,
  GET_SUB_SPECIALIZATION,
  GET_SUB_INDUSTRY,
  GET_FRIENDS_LIST_BASED_WORKSPACE,
} from "../types";

const initialState = {
  subjectslist: [],
  languagelist: [],
  taglist: [],
  gradelist: [],
  curriculumtracklist: [],
  schoollist: [],
  friendslist: [],
  industrylist: [],
  regionlist: [],
  areaofinterestlist: [],
  professionList: [],
  expectationInterestList: [],
  expectationHelpList: [],
  joinedSubjectList: [],
  chatFriendslist: [],
  blockedUserList: [],
  homeImageState: false,
  workspaceType: "default",
  userWorkSpaceList: [],
  workspaceListHeader: "default",
  role: 0,
  adminCategoryList: [],
  countryName: [],
  workSpaceLogin: false,
  loading: true,
  wrongUrlStatus: false,
  pathUrl: "url",
  tourApiCalled: false,
  completedTours: 0,
  popupLocation: "",
  toursStages: {
    header: {
      headerFinish: true,
      totalHeaderCount: 0,
      headerSkipped: 0,
    },
    profile: {
      profileFinish: true,
      totalProfileCount: 0,
      profileSkipped: 0,
    },
    connection: {
      connectionFinish: true,
      totalConnectionCount: 0,
      connectionSkipped: 0,
    },
    community: {
      communityFinish: true,
      communitySkipped: 0,
      totalCommunityCount: 0,
    },
    post: {
      postFinish: true,
      totalPostCount: 0,
      postSkipped: 0,
    },
    askHelp: {
      askHelpFinish: true,
      totalAskHelpCount: 0,
      askHelpSkipped: 0,
    },
    learningHub: {
      learningHubFinish: true,
      totalLearningHubCount: 0,
      learningHubSkipped: 0,
    },
  },
  popupStatus: false,
  profilePopupStatus: false,
  communityPopupStatus: false,
  connectionPopupStatus: false,
  homePopupStatus: false,
  askHelpPopupStatus: false,
  headerPopupStatus: false,
  learningPopupStatus: false,
  announcementList: [],
  tagUserList: [],
  adminCountryList: [],
  getWorkSpaceOption: {},
  hashTagList: [],
  renderComponent: false,
  requireMentMenu: {},
  needToPopUp: false,
  subIndustry: [],
  subSpecialization: [],
  workspaceFriendList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case NEED_PHOTO_VERIFICATION:
      return {
        ...state,
        needToPopUp: action.payload,
      };
    case GET_ALL_COMMON_SUBJECTS:
      return {
        ...state,
        subjectslist: action.payload,
        loading: false,
      };
    case GET_ALL_USER_COMMUNITY_LIST:
      return {
        ...state,
        joinedSubjectList: action.payload.data,
        loading: false,
      };
    case GET_ALL_COMMON_LANGUAGE:
      return {
        ...state,
        languagelist: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_ALL_PROOF:
      return {
        ...state,
        proofList: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_TAGS:
      return {
        ...state,
        taglist: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_GRADES:
      return {
        ...state,
        gradelist: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_CURRICULUM_TRACK:
      return {
        ...state,
        curriculumtracklist: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_SCHOOL:
      return {
        ...state,
        schoollist: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_FRIENDS_LIST:
      return {
        ...state,
        friendslist: action.payload,
        loading: false,
      };

    case GET_ALL_BLOCKED_USER_LIST:
      return {
        ...state,
        blockedUserList: action.payload,
        loading: false,
      };

    case GET_ALL_COMMON_CHAT_FRIENDS_LIST:
      return {
        ...state,
        chatFriendslist: action.payload,
        loading: false,
      };
    case GET_INDUSTRY_LIST:
      return {
        ...state,
        industrylist: action.payload,
        loading: false,
      };
    case GET_REGION_LIST:
      return {
        ...state,
        regionlist: action.payload,
        loading: false,
      };
    case GET_AREA_OF_INTEREST_LIST:
      return {
        ...state,
        areaofinterestlist: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_PROFESSION:
      return {
        ...state,
        professionList: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_EXPECTATION_HELP:
      return {
        ...state,
        expectationHelpList: action.payload,
        loading: false,
      };
    case GET_ALL_COMMON_EXPECTATION_INTEREST:
      return {
        ...state,
        expectationInterestList: action.payload,
        loading: false,
      };

    case NAVIGATION_TYPE:
      return {
        ...state,
        navigationType: action.payload,
      };
    case HOME_IMAGE_STATUS:
      return {
        ...state,
        homeImageState: action.payload,
      };

    case GET_USER_POINTS:
      return {
        ...state,
        totalUserPoints: action.payload,
      };
    case WORK_SPACE_TYPE:
      var name = action.payload.type?.trim();
      name = name?.replace(/[, ]+/g, "-").trim();
      return {
        ...state,
        workspaceListHeader: action.payload.type,
        workspaceType: name,
        role: action.payload.role,
      };
    case GET_LOGOUT_DATA:
      return {
        ...initialState,
      };
    case GET_USER_WORKSPACE_LIST:
      return {
        ...state,
        userWorkSpaceList: action.payload,
        loading: false,
      };
    case GET_ADMIN_CATEGORY_LIST:
      return {
        ...state,
        adminCategoryList: action.payload,
        loading: false,
      };
    case GET_ALL_COUNTRY_PHONE_CODE:
      return {
        ...state,
        countryName: action.payload,
      };

    case WORK_SPACE_LOGIN:
      return {
        ...state,
        workSpaceLogin: action.payload,
      };

    case WORK_SPACE_WRONG_URL:
      return {
        ...state,
        wrongUrlStatus: action.payload,
        pathUrl: action.pathUrl,
      };

    case GET_TOUR_STATUS:
      return {
        ...state,
        toursStages: action.payload ? action.payload : state.toursStages,
        tourApiCalled: true,
      };

    case TRIGGER_TOUR_POPUP:
      return {
        ...state,
        popupLocation: action.payload,
        popupStatus: !state.popupStatus,
      };
    case AFTER_TRIGGER_POPUP:
      switch (action.payload) {
        case "header":
          return {
            ...state,
            headerPopupStatus: true,
          };
        case "home":
          return {
            ...state,
            homePopupStatus: true,
          };
        case "connection":
          return {
            ...state,
            connectionPopupStatus: true,
          };
        case "profile":
          return {
            ...state,
            profilePopupStatus: true,
          };
        case "askHelp":
          return {
            ...state,
            askHelpPopupStatus: true,
          };
        case "community":
          return {
            ...state,
            communityPopupStatus: true,
          };
        case "learning":
          return {
            ...state,
            learningPopupStatus: true,
          };
        default:
          return state;
      }

    case SAVE_TOUR_STATUS:
      return {
        ...state,
        toursStages: action.payload ? action.payload : state.toursStages,
      };
    case ANNOUNCEMENT_DETAILS:
      return {
        ...state,
        announcementList: action.payload ? action.payload : [],
      };
    case GET_TAG_USER_LIST:
      return {
        ...state,
        tagUserList: action.payload ? action.payload : [],
      };

    case GET_WORKSPACE_OPTIONS:
      return {
        ...state,
        getWorkSpaceOption: action.payload ? action.payload : {},
      };
    case HASH_TAG_LIST:
      return {
        ...state,
        hashTagList: action.payload ? action.payload : {},
      };
    case NEED_RENDER_COMPONENT:
      return {
        ...state,
        renderComponent: action.payload,
      };
    case GET_REQUIREMENT_STATUS:
      if (action.needUpdate) {
        const old = state.requireMentMenu;
        old.sellerExist = true;
        return {
          ...state,
          requireMentMenu: old ? old : state.requireMentMenu,
        };
      } else {
        return {
          ...state,
          requireMentMenu: action.payload,
        };
      }
    case GET_SUB_SPECIALIZATION:
      return {
        ...state,
        subSpecialization: action.payload ? action.payload : [],
      };
    case GET_SUB_INDUSTRY:
      return {
        ...state,
        subIndustry: action.payload ? action.payload : [],
      };

    case GET_FRIENDS_LIST_BASED_WORKSPACE:
      return {
        ...state,
        workspaceFriendList: action.payload ? action.payload : [],
      };
    default:
      return state;
  }
}
